<script>
  import { createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher();
  const dispatchClick = () => {
    dispatch('click');
  };
</script>

<style style="text/scss" lang="scss">
  $width: 120px;
  $height: 36px;
  $y: 130px;

  .m-map-button {
    position: fixed;
    z-index: 7;
    top: $y;
    left: calc(50vw - $width / 2);
    width: $width;
    height: $height;
    background: rgba(0, 0, 0, 0.75);
    border-radius: 75px;
    border: 0px;
  }

  .m-map-button__content {
    width: 100%;
    height: 100%;
    padding: 0px 14px;

    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
  }

  .m-map-button__text {
    font-size: 14px;
    font-weight: 500;
    color: white;
  }
</style>

<button class="m-map-button" on:click={dispatchClick}>
  <div class="m-map-button__content">
    <span class="m-map-button__text">Back to list</span>
  </div>
</button>
